import React from 'react';
import { LogIn, KeyRound } from 'lucide-react';

const OPTIONS = [
  ['login', LogIn, 'Easy way: use your login', 'Paste the link to your inventory page and the username and password you use there. Takes 1 minute.', 'Recommended'],
  ['api', KeyRound, 'API link and key', 'If your software provider gives you an API link and key. Best for large or complex systems.', null],
];

export const ConnectChoice = ({ onPick }) => (
  <div className="grid sm:grid-cols-2 gap-3" data-testid="connect-choice">
    {OPTIONS.map(([key, Icon, title, desc, badge]) => (
      <button key={key} type="button" onClick={() => onPick(key)} data-testid={`connect-choice-${key}`}
        className="text-left rounded-xl border border-border p-4 hover:border-primary hover:bg-primary/5 transition-colors">
        <div className="flex items-center justify-between mb-2">
          <Icon className="w-5 h-5 text-primary" />
          {badge && <span className="text-[10px] uppercase tracking-wide font-semibold bg-primary/10 text-primary px-2 py-0.5 rounded-full">{badge}</span>}
        </div>
        <p className="font-semibold text-foreground">{title}</p>
        <p className="text-sm text-muted-foreground mt-1">{desc}</p>
      </button>
    ))}
  </div>
);
